const getTmDataToUpdate = (sliceOrientation, ijk, dimensionsIJK) => {
	return {
		...(sliceOrientation === "axial" && {r2: dimensionsIJK.x - ijk.x, r3: ijk.z}),
		...(sliceOrientation === "sagittal" && {r1: dimensionsIJK.y - ijk.y, r3: ijk.z}),
		...(sliceOrientation === "coronal" && {r1: dimensionsIJK.y - ijk.y, r2: dimensionsIJK.x - ijk.x}),
	}
};
export default getTmDataToUpdate;